/* tslint:disable */
/* eslint-disable */
export enum CustomerServiceStatus {
  $0 = 0,
  $1 = 1
}
